import { get, post } from '@/request/request'

export default {
    list(params) {
        return get('/admin/daily/log/list', params)
    },
    add(params) {
        return post('/admin/daily/log/add',params)
    }
}